import { useRouter } from 'next/router';

import { PageLayout } from '@bpm-web-app/components';
import { VideoBySlug } from '@bpm-web-app/components/pages';

export default function AcademyDetailPage() {
    const {
        query: { slug },
    } = useRouter();

    return (
        <PageLayout hasHubSwitch={false}>
            <VideoBySlug slug={slug as string} />
        </PageLayout>
    );
}
